<script setup>
import TabEstado from "./TabEstado.vue";
import HistorialDeMovimientos from "./HistorialDeMovimientos.vue";
import SelectorCuitLote from "./SelectorCuitLote.vue";
import { storeToRefs } from "pinia";
import SpinnerLoader from "@/components/Spinner/SpinnerLoader";

import {
  formatearInputMoneda,
  truncarTexto,
  truncarTextoTitulo,
} from "@/utils/helpers";


const props = defineProps({
  historialDeOfertasStore: Object,
});

const emit = defineEmits(["irASubasta"]);

const { selected_pujas: selectedPujas, selectAllCheck: selectAllCheck } = storeToRefs(props.historialDeOfertasStore);

</script>

<template>
  <div class="card card_mobile">
    <SpinnerLoader v-if="historialDeOfertasStore.cargandoHistorial" size="64px"/>
    <div class="card-header mb-1 pb-0">
      <div class="row border-bottom border-3">
        <div class="col-3 p-1">
          <p class="text-start text-soft-grey-74 fw-600">Detalle</p>
        </div>
        <div class="col-2 p-1">
          <p class="text-center text-soft-grey-74 fw-600">Oferta vigente</p>
        </div>
        <div class="col-2 p-1">
          <p class="text-center text-soft-grey-74 fw-600">
            CUIT para facturación
          </p>
        </div>
        <div class="col-2 p-1">
          <p class="text-center text-soft-grey-74 fw-600">Estado de oferta</p>
        </div>
        <div class="col-2 p-1">
          <p class="text-center text-soft-grey-74 fw-600">
            Estado de aprobación
          </p>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-end">
          <div class="form-check m-0 d-flex align-items-center">
            <input
              id="check-all"
              class="form-check-input checkbox_cuit"
              type="checkbox"
              v-model="selectAllCheck"
              @change="
                historialDeOfertasStore.toggleSelectAll()
              "
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card-body pt-0">
      <div
        v-if="historialDeOfertasStore.selected_tab.listado.length === 0"
        class="row align-items-center border-bottom border-2 py-5"
      >
        <div class="col-12">
          <div
            class="d-flex flex-column align-items-center justify-content-center"
          >
            <i
              class="fa-solid fa-inbox mb-2"
              style="opacity: 0.6; font-size: 1.6rem"
            ></i>
            <p class="mb-0 text-soft-grey-74 fw-600">
              {{
                historialDeOfertasStore.selected_tab.busca_sin_datos ||
                "No hay registros para mostrar"
              }}
            </p>
          </div>
        </div>
      </div>
      <div
        v-for="puja in historialDeOfertasStore.selected_tab.listado"
        :key="puja.id"
        class="row align-items-center border-bottom border-2 py-4"
      >
        <div class="col-3">
          <div
            class="d-flex flex-column bloque_accion"
            @click="emit('irASubasta', puja.lote.id)"
          >
            <strong class="titulo_subasta_id text_black"
              >ID {{ puja.subasta.external_id }}</strong
            >
            <h6 class="titulo_subasta text_black mb-0">
              {{ truncarTextoTitulo(puja.subasta.titulo) }}
            </h6>
            <p class="text-black mb-0">
              Lote N°{{ puja.lote.codintlote }}
              {{ truncarTexto(puja.lote.titulo) }}
            </p>
          </div>
        </div>

        <div class="col-2">
          <p
            class="text-uppercase p-1 text_black text-center text_tabla fw-bold opacity-7 mb-0"
          >
            $ {{ formatearInputMoneda(puja.oferta_actual) }}
          </p>
        </div>

        <div class="col-2 d-flex justify-content-center">
          <SelectorCuitLote
            v-if="historialDeOfertasStore.puedeElegirCuit(puja)"
            :puja="puja"
            :historialDeOfertas="historialDeOfertasStore"
          />
        </div>

        <div class="col-2 p-1">
          <TabEstado :puja="puja" :user-id="historialDeOfertasStore.usuarioStore.user?.id" />
        </div>

        <div class="col-2">
          <div
            v-if="historialDeOfertasStore.puedeElegirCuit(puja)"
            class="d-flex flex-column align-items-center"
          >
            <span
              v-if="historialDeOfertasStore.textoAprobacion(puja)"
              class="badge badge-sm badge_aprobacion align-items-center"
            >
              <i class="fa-solid fa-tag"></i>
              {{ historialDeOfertasStore.textoAprobacion(puja) }}
            </span>
          </div>
        </div>

        <div class="col-1 d-flex justify-content-end">
          <div class="form-check m-0">
            <input
              class="form-check-input checkbox_cuit"
              type="checkbox"
              v-if="historialDeOfertasStore.puedeMarcarCheckbox(puja)"
              v-model="selectedPujas"
              :value="puja"
            />
          </div>
        </div>

        <div class="col-6 mt-3">
          <div
            class="d-inline-flex align-items-center cursor-pointer"
            @click="historialDeOfertasStore.toggleMostrarMovimientos(puja.id)"
          >
            <h6 class="pe-2 mb-0">Historial de Movimientos</h6>
            <i class="fa-solid mt-1 fa-angle-right fs-13"></i>
          </div>
        </div>
        <div class="col-6 mt-3">
          <button
            v-if="
              puja.lote.estado_lote.slug === 'en-subasta' &&
              historialDeOfertasStore.usuarioStore.user?.id !== puja.user_ultima_oferta_id
            "
            class="btn btn-soft-green pt-1 pb-1 mb-2 float-end"
            @click="emit('irASubasta', puja.lote.id)"
          >
            Ofertar
          </button>
        </div>

        <HistorialDeMovimientos
          v-if="historialDeOfertasStore.mostrarMovimientos.includes(puja.id)"
          :movimientos="puja.ofertas"
          :usuario_id="historialDeOfertasStore.usuarioStore.user?.id"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.bloque_accion:hover {
  cursor: pointer !important;
}
.text_black {
  color: black !important;
}
.text_tabla {
  font-size: 1.1em !important;
}

.checkbox_cuit {
  min-width: 20px !important;
  max-width: 20px !important;
  min-height: 20px !important;
  max-height: 20px !important;
}

.badge_aprobacion {
  background-color: #231f20 !important;
  color: #fff;
  max-width: fit-content !important;
  min-width: 100px !important;
  padding: 10px 12px !important;
  font-size: 1em !important;
}

.titulo_subasta {
  font-size: large;
}

@media (max-width: 990px) {
  .titulo_subasta {
    font-size: 1rem;
  }
  .text_tabla {
    font-size: 0.9rem;
  }
  .badge_aprobacion {
    font-size: 0.85rem;
  }
}

@media (max-width: 768px) {
  .text_tabla {
    font-size: 0.85rem;
  }
  .badge_aprobacion {
    font-size: 0.8rem;
  }
}
</style>
